import { createSlice } from "@reduxjs/toolkit";

const initialLogsTabUserProfileNewState = {
  logListLoading: false,
  actionsLoading: false,
  totalCount: 0,
  requestLogsList: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const LogsTabUserProfileNewSlice = createSlice({

  name: "walletTabUserProfileNew",
  initialState: initialLogsTabUserProfileNewState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.logListLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.logListLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.requestLogsList = []
    },

    usersLogsList: (state, action) => {
      console.log(action.payload);
      state.logListLoading = false;
      state.requestLogsList = action.payload.data;
      state.totalCount = action.payload.totalRecord;
    },
  }
});
